import { render, staticRenderFns } from "./modalOsRetornos.vue?vue&type=template&id=b305eb62&scoped=true"
import script from "./modalOsRetornos.vue?vue&type=script&lang=js"
export * from "./modalOsRetornos.vue?vue&type=script&lang=js"
import style0 from "./modalOsRetornos.vue?vue&type=style&index=0&id=b305eb62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b305eb62",
  null
  
)

export default component.exports